export default "__VITE_ASSET__9b3cb0ce__"